import * as React from 'react';
import { Vegobjekttype } from '@/domain/vegobjekter/Vegobjekttype';
import { VegobjekttypeCategoryState, VegobjekttypeState } from '@/state';
import { defaultColor, resolveColor } from '@/utils/ColorHelper';
import { CategoryResult } from './CategoryResult';

interface Props {
    vegobjekttype: Vegobjekttype;
    vegobjekttypeData: VegobjekttypeState;
    categoryStates: VegobjekttypeCategoryState[];
    categoryName: string;
    onOpenColorMenu: (
        categoryState: VegobjekttypeCategoryState,
        anchor: { x: number; y: number }
    ) => void;
}

export const CategoryResultList = function CategoryResultList({
    vegobjekttype,
    vegobjekttypeData,
    categoryStates,
    categoryName,
    onOpenColorMenu,
}: Props) {
    const categoriesWithResults = categoryStates
        .filter(
            category =>
                (category.result?.totalStatistics?.antall ?? 0) > 0 ||
                (category.result?.extentStatistics?.antall ?? 0) > 0
        )
        .sort(VegobjekttypeCategoryState.comparator);

    return (
        <ul
            className="c-category-result-list"
            aria-label={`Kategorier for ${categoryName}`}
        >
            {categoriesWithResults.map(category => {
                if (!category.result) {
                    return null;
                }

                const color =
                    category.color != null ? resolveColor(category.color) : defaultColor;
                return (
                    <CategoryResult
                        key={category.toString()}
                        vegobjekttype={vegobjekttype}
                        vegobjekttypeData={vegobjekttypeData}
                        categoryState={category}
                        result={category.result}
                        color={color}
                        onOpenColorMenu={onOpenColorMenu}
                    />
                );
            })}
        </ul>
    );
};
